// Setup Firebase Cloud Messaging (push notifications).
//
// Estratto dallo `<script>` inline che era in `index.html` con l'SDK CDN v8.
// Usa il compat layer (`firebase` import) per mantenere la stessa API.

import firebase from './firebase';

const VAPID_PUBLIC_KEY =
  'BPYM6UaccQRD9yG_N0eIQPGELdCEXVaKjaXCXSBnyQdfMkjk42N_A8vY6g2IYW6AqvdHgM3lrOUiU7oSPlUg8gQ';

function setTokenSentToServer(sent) {
  window.localStorage.setItem('sentToServer', sent ? '1' : '-1');
}

function sendTokenToServer(currentToken) {
  const user = firebase.auth().currentUser;
  if (!user) return;
  firebase.firestore().collection('users').doc(user.uid).update({ token: currentToken });
  setTokenSentToServer(true);
}

export function initMessaging() {
  if (!('serviceWorker' in navigator)) return;
  if (!firebase.messaging.isSupported || !firebase.messaging.isSupported()) return;

  const messaging = firebase.messaging();

  messaging.onMessage((payload) => {
    // hook per future notifiche in-app
    const notification = payload?.data?.notification;
    if (notification) console.info('FCM payload', payload, notification);
  });

  Notification.requestPermission()
    .then((permission) => {
      if (permission !== 'granted') return;

      messaging
        .getToken({ vapidKey: VAPID_PUBLIC_KEY })
        .then((currentToken) => {
          if (currentToken) sendTokenToServer(currentToken);
          else setTokenSentToServer(false);
        })
        .catch(() => setTokenSentToServer(false));
    })
    .catch((err) => console.error('Unable to get permission to notify.', err));
}
